<div class="form-array-wrapper">
  <!-- Modern Array Header -->
  <div class="array-header">
    <div class="header-info">
      <h5 class="array-title">{{ title || (arrayName | titlecase) }}</h5>
      <span class="array-count">{{ formGroups.length }} {{ formGroups.length === 1 ? 'Item' : 'Items' }}</span>
    </div>
    <button class="btn-add-item" (click)="addRow()" type="button">
      <i class="pi pi-plus"></i>
      <span>Add New</span>
    </button>
  </div>

  <!-- Array Content Grid -->
  <div class="array-items">
    <div
      *ngFor="let group of formGroups; let i = index"
      class="array-row-card shadow-sm"
    >
      <!-- Premium Row Header -->
      <div class="row-card-header">
        <span class="row-index">Entry #{{ i + 1 }}</span>
        <button
          *ngIf="formGroups.length > 1"
          class="btn-remove-row"
          (click)="removeRow(i)"
          type="button"
          title="Remove Item"
        >
          <i class="pi pi-trash"></i>
        </button>
      </div>

      <!-- Sophisticated Row Body -->
      <div class="row-card-body">
        <ng-container *ngFor="let field of fields">
          <div class="field-group" [style.grid-column]="field.col_size == 12 ? '1 / -1' : 'span 1'">
            <label class="field-label">{{ getFieldLabel(field) }}</label>
            
            <div class="field-input-container">
              <!-- Standard Text Input -->
              <input
                *ngIf="!field.type || field.type === 'text'"
                type="text"
                class="form-control premium-input"
                [formControl]="group.get(field.colName) || dummyControl"
                [placeholder]="field.title"
              />

              <!-- PrimeNG Dropdown for Modal Support -->
              <p-dropdown
                *ngIf="field.type === 'select'"
                appendTo="body"
                [baseZIndex]="10000"
                styleClass="w-100 premium-dropdown"
                [options]="field.data || []"
                [optionLabel]="field.selectKeyName || 'name'"
                [optionValue]="field.selectPrimaryKey || 'id'"
                [formControl]="$any(group.get(field.colName) || dummyControl)"
                [placeholder]="'Select ' + field.title"
              ></p-dropdown>

              <!-- Checkbox (Modernized) -->
              <div *ngIf="field.type === 'checkbox'" class="mt-2 text-left">
                <label class="fancy-checkbox m-0">
                  <input
                    type="checkbox"
                    [formControl]="group.get(field.colName) || dummyControl"
                  />
                  <span>{{ field.title }}</span>
                </label>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
